import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Box,
  Divider,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

export default function FamilyDetailsDialog({ open, family, onClose }) {
  if (!family) return null

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          boxShadow: '0 25px 50px -12px rgb(0 0 0 / 0.25)',
        },
      }}
    >
      <DialogTitle
        sx={{
          pb: 2,
          borderBottom: '1px solid',
          borderColor: 'divider',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography variant="h6" component="div">
          {family.family_name}
        </Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            color: 'text.secondary',
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ pt: 3 }}>
        {family.phone && (
          <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
              Phone
            </Typography>
            <Typography>{family.phone}</Typography>
          </Box>
        )}

        {family.address && (
          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
              Address
            </Typography>
            <Typography>{family.address}</Typography>
          </Box>
        )}

        <Typography variant="subtitle2" color="text.secondary" gutterBottom>
          Family Members
        </Typography>
        {family.contacts && family.contacts.length > 0 ? (
          <List sx={{ pt: 0 }}>
            {family.contacts.map((contact) => (
              <React.Fragment key={contact.id}>
                <ListItem sx={{ px: 0 }}>
                  <ListItemText
                    primary={`${contact.first_name} ${contact.last_name}`}
                    secondary={
                      <>
                        {contact.phone && (
                          <Typography variant="body2" component="span" display="block">
                            {contact.phone}
                          </Typography>
                        )}
                        {contact.email && (
                          <Typography variant="body2" component="span">
                            {contact.email}
                          </Typography>
                        )}
                      </>
                    }
                  />
                </ListItem>
                <Divider component="li" />
              </React.Fragment>
            ))}
          </List>
        ) : (
          <Typography color="text.secondary">No family members</Typography>
        )}
      </DialogContent>
    </Dialog>
  )
}
